export default __webpack_public_path__ + "static/media/DSC05287.5a33ed7e.webp";